function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.0001 3H14.0001L14.404 5.42373C15.1717 5.70444 15.8765 6.11572 16.4914 6.63069L18.7943 5.76797L20.7943 9.23207L18.8966 10.7943C18.9646 11.186 19 11.5889 19 12C19 12.4111 18.9646 12.814 18.8966 13.2056L20.7943 14.768L18.7943 18.2321L16.4914 17.3693C15.8765 17.8843 15.1717 18.2956 14.404 18.5763L14.0001 21H10.0001L9.59613 18.5763C8.82844 18.2956 8.12364 17.8843 7.50863 17.3694L5.20581 18.2321L3.20581 14.768L5.10346 13.2058C5.03545 12.814 5 12.4112 5 12C5 11.5888 5.03545 11.1859 5.10346 10.7942L3.20589 9.23206L5.20589 5.76796L7.50863 6.63065C8.12364 6.11566 8.82843 5.70437 9.59613 5.42367L10.0001 3ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
});

var SvgSettings = function SvgSettings(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Settings.632f1419.svg";
export { ForwardRef as ReactComponent };